var React = require('react');

function SecurityInfoBackground (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"security-info-background"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"security-info-background"},React.createElement("g",{"transform":"translate(0.000000, 0.000000)","id":"Rectangle"},[React.createElement("polygon",{"fill":"#2E5E4E","points":"0 45.5 500 17 500 74 0 74","key":0}),React.createElement("polygon",{"fill":"#0CC982","points":"0 0 500 74 0 74","key":1})])))]);
}

SecurityInfoBackground.defaultProps = {"width":"500px","height":"74px","viewBox":"0 0 500 74","version":"1.1"};

module.exports = SecurityInfoBackground;

SecurityInfoBackground.default = SecurityInfoBackground;
